import { apiConstants } from './shared/config';

const authAccess = { roles: ['GP_00001'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao" */ './views/Home.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Gestão',
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-settings" */ './views/settings/GlobalSettingsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `settings.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/newscategories`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news_categories" */ './views/newsCategory/NewsCategoryBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.news_categories`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news_categories" */ './views/newsCategory/NewsCategoryList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'news_categories.titles',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.news_categories.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news_categories" */ './views/newsCategory/NewsCategoryDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'news_categories.title',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.news_categories.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news_categories" */ './views/newsCategory/NewsCategoryDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'news_categories.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'news_categories.titles',
        }
    },
    {
        path: `/${apiConstants.code}/news`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news" */ './views/news/NewsBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.news`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news" */ './views/news/NewsList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Notícias',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.news.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news" */ './views/news/NewsDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Notícia',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.news.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-news" */ './views/news/NewsDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Notícia',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Notícia',
        }
    },
    {
        path: `/${apiConstants.code}/pages`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-pages" */ './views/pages/PageBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.pages`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-pages" */ './views/pages/PageList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.pages.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-pages" */ './views/pages/PageDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.pages.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoportalgestao-pages" */ './views/pages/PageDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `pages.titles`,
        }
    },
];

export default routes;
